// @flow

export const NONE: string = 'NONE';
export const LOADING: string = 'LOADING';
export const LOADED: string = 'LOADED';
export const PENDING: string = 'PENDING';
export const SUCCESS: string = 'SUCCESS';
export const ERROR: string = 'ERROR';
export const NOT_FOUND: string = 'NOT_FOUND';
